import { useState } from 'react';
import Script from 'next/script';

import { useEffectOnce, useGlobalEvent, useValueChangeEffect } from 'hooks';

export interface YouTubeGlobalEvents {
	'youtube-api-ready': undefined;
}
const READY_EVENT = 'youtube-api-ready' satisfies keyof YouTubeGlobalEvents;

interface Props {
	onReady?: () => void;
}

export default function YouTubeAPILoader({ onReady }: Props) {
	const [isReady, setIsReady] = useState(false);

	useGlobalEvent(READY_EVENT, () => {
		setIsReady(true);
	});

	// API could already be loaded from earlier renders.
	useEffectOnce(() => {
		if (globalThis.YT?.Player) {
			setIsReady(true);
		}
	});

	useValueChangeEffect(isReady, () => {
		if (isReady) {
			onReady?.();
		}
	});

	// 'Map' the global callback to an event to let multiple instances of the
	// component react to it.
	return (
		<>
			<Script id="youtube-iframe-api-event">
				{`window.onYouTubeIframeAPIReady=()=>{window.dispatchEvent(new CustomEvent('${READY_EVENT}'))}`}
			</Script>
			<Script
				id="youtube-iframe-api"
				src="https://www.youtube.com/iframe_api"
			/>
		</>
	);
}
YouTubeAPILoader.displayName = 'YouTubeAPILoader';
